<mat-card appearance="outlined">
    <mat-card-content>
        <a mat-raised-button routerLink="/pricing" color="primary">Upgrade Now</a>
    </mat-card-content>
</mat-card>
